import { Component, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { CompanyDTO, MemberEnrollmentDTO } from 'src/app/core/models/auth';
import { AuthService } from 'src/app/core/services/shared-services/auth.service';
import { NotificationService } from 'src/app/core/services/shared-services/notification.service';
import { UserRegistrationService } from 'src/app/core/services/user-registration.service';
import { PageTitle } from 'src/app/shared/app.constants';
import { RegExpression } from 'src/app/shared/app.enums';

@Component({
  selector: 'eb-new-registration',
  templateUrl: './new-registration.component.html',
})
export class NewRegistrationComponent implements OnInit {
  @ViewChild('errorContainer', { static: true, read: ViewContainerRef }) errorContainer: ViewContainerRef;
  registrationForm!: FormGroup;
  company: CompanyDTO | undefined;
  member: MemberEnrollmentDTO | undefined;
  idCompany: number | undefined;
  tpaCode: string | undefined;
  idTPA: number | undefined;
  tpaCompanyID: string | undefined;
  isFormValid = false;
  enableWebAppVersionV6: boolean;
  isEmailSend: boolean = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private userRegistrationService: UserRegistrationService,
    private notificationService: NotificationService,
    private titleService: Title
  ) {
    this.titleService.setTitle(PageTitle.Registration);
  }

  ngOnInit() {
    this.notificationService.targetElement = this.errorContainer;
    this.registrationForm = this.fb.group({
      email: new FormControl('', [Validators.required, Validators.email]),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      homeZipCode: new FormControl('', [Validators.required]),
    });
    let companyData = this.userRegistrationService.getCompanyData;
    if (companyData) {
      this.idCompany = companyData?.idCompany;
      this.tpaCode = companyData?.tpaCode;
      this.tpaCompanyID = companyData?.tpaCompanyID;
      this.enableWebAppVersionV6 = companyData?.enableWebAppVersionV6;
      this.idTPA = companyData?.idTPA;
    }
  }
  dynamicFieldValidation(): void {
    if (this.registrationForm.get('homeZipCode').value?.length > 0) {
      this.registrationForm.get('homeZipCode').addValidators([Validators.pattern(RegExpression.RegistrationZipCode)]);
    } else {
      this.registrationForm
        .get('homeZipCode')
        .removeValidators([Validators.pattern(RegExpression.RegistrationZipCode)]);
    }
    if (this.registrationForm.get('email').value) {
      if (this.isInvalidEmail(this.registrationForm.get('email').value)) {
        this.registrationForm.get('email').setValue('');
      }
    }
  }

  isInvalidEmail(email: string): boolean {
    const invalidEmail = [
      '@noemail.com',
      '@noemail7.com',
      '@noname.com',
      'email@email.com',
      'email@noemail7.com',
      'noname@noname.com',
    ];
    return !email || invalidEmail.some(domain => email.endsWith(domain));
  }

  sendVerificationEmail() {
    const enrollment = {
      idCompany: this.idCompany,
      idTPA: this.idTPA,
      tpaCompanyID: this.tpaCompanyID,
      fname: this.registrationForm.get('firstName')?.value,
      lName: this.registrationForm.get('lastName')?.value,
      zip: this.registrationForm.get('homeZipCode')?.value,
      email: this.registrationForm.get('email')?.value,
      redirectUri: window.location.origin + '/set-up-your-account-v2',
    };
    this.authService.validateMember(enrollment).subscribe((response: any) => {
      if (response?.succeeded) {
        this.isEmailSend = true;
      }
    });
  }

  emailResend() {
    this.sendVerificationEmail();
  }
}
